import React, { useState } from "react";
import { Col, Pagination, Button } from "react-bootstrap";
import BTable from "react-bootstrap/Table";
import {
  useTable,
  useFilters,
  useSortBy,
  usePagination,
  useGlobalFilter,
  useAsyncDebounce,
} from "react-table";
import "./Tables.css";
import { useEffect } from "react";

// Define a default UI for filtering
function GlobalFilterGeneric({
  preGlobalFilteredRows,
  globalFilter,
  setGlobalFilter,
  filterBtn,
  setfilterBtn,
}) {
  // const count = preGlobalFilteredRows.length;
  const [value, setValue] = React.useState(globalFilter);
  const onChange = useAsyncDebounce((value) => {
    setGlobalFilter(value || undefined);
  }, 200);

  const handleFilter = () => {
    if (filterBtn) {
      setfilterBtn(false);
    } else {
      setfilterBtn(true);
    }
  };

  return (
    <span className="d-flex align-items-center">
      Buscar:{" "}
      <input
        className="form-control ml-3"
        value={value || ""}
        onChange={(e) => {
          setValue(e.target.value);
          onChange(e.target.value);
        }}
        //placeholder={`${count} registros...`}
        style={{
          fontSize: "1.1rem",
          border: "0",
        }}
      />
      <span>
        <Button
          style={
            filterBtn
              ? { backgroundColor: "transparent" }
              : { backgroundColor: "transparent", borderColor: "transparent" }
          }
          onClick={handleFilter}
        >
          <i className="feather icon-filter" />
        </Button>
      </span>
    </span>
  );
}

//button si es true se vera el boton
function GenericTable({
  columns,
  data,
  button,
  nameButton,
  funcion,
  options,
  pages,
  doubleClic,
  variantButton,
  defaultSize,
  setResumen,
  mainPage,
}) {
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    setGlobalFilter,
    page,
    canPreviousPage,
    canNextPage,
    pageOptions,
    pageCount,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    state: { pageIndex, pageSize },
    state,
    visibleColumns,
    preGlobalFilteredRows,
  } = useTable(
    {
      columns,
      data,
      initialState: { pageIndex: 0, pageSize: defaultSize || 10 },
    },
    useFilters, // useFilters!
    useGlobalFilter,
    useSortBy,
    usePagination,
  );
  const [filterBtn, setfilterBtn] = useState(false);

  useEffect(() => {
    //Sumar los totales por filtro de la tabla en Detalle de ventas
    if (mainPage === "DetalleVentas" && state.globalFilter) {
      const totalVenta = page.reduce(
        (sum, item) => sum + Number(item?.original?.total),
        0,
      );
      const cantidadTotal = page.reduce(
        (sum, item) => sum + Number(item?.original?.cantidad),
        0,
      );
      const beneficios = page.reduce(
        (sum, item) => sum + Number(item?.original?.beneficioNeto),
        0,
      );
      const porcBenefCosto = page.reduce(
        (sum, item) => sum + Number(item?.original?.porcBenefCosto),
        0,
      );
      const porcBeneficio = ((beneficios * 100) / totalVenta).toFixed(2);
      setResumen({
        totalVenta,
        cantidadTotal,
        beneficios,
        porcBenefCosto,
        porcBeneficio,
      });
    } else if (mainPage === "DetalleVentas" && !state.globalFilter) {
      setResumen();
    } else if (mainPage === "resumenPagos" && state.globalFilter) {
      //Sumar totales en resumen de pagos
      const totalEefectivo = page.reduce((sum, item) => {
        if (
          item?.original?.metodo_pago === "Efectivo" &&
          item?.original?.estatus !== "Anulado"
        ) {
          return sum + Number(item?.original?.pago);
        }
        return sum;
      }, 0);
      const totalTransferencia = page.reduce((sum, item) => {
        if (
          item?.original?.metodo_pago === "Transferencia" &&
          item?.original?.estatus !== "Anulado"
        ) {
          return sum + Number(item?.original?.pago);
        }
      }, 0);
      const totalTarjeta = page.reduce((sum, item) => {
        if (
          item?.original?.metodo_pago === "Tarjeta" &&
          item?.original?.estatus !== "Anulado"
        ) {
          return sum + Number(item?.original?.pago);
        }
        return sum;
      }, 0);
      const totalOtros = page.reduce((sum, item) => {
        if (
          item?.original?.metodo_pago !== "Efectivo" &&
          item?.original?.metodo_pago !== "Transferencia" &&
          item?.original?.metodo_pago !== "Tarjeta" &&
          item?.original?.estatus !== "Anulado"
        ) {
          return sum + Number(item?.original?.pago);
        }
        return sum;
      }, 0);
      setResumen({
        efectivo: totalEefectivo,
        transferencia: totalTransferencia,
        tarjeta: totalTarjeta,
        otros: totalOtros,
      });
    } else if (mainPage === "resumenPagos" && !state.globalFilter) {
      setResumen();
    }
  }, [page]);

  return (
    <>
      <div className="inv-table-scroll">
        {button ? (
          <Col className="d-flex justify-content-end">
            <Button
              variant={variantButton || "success"}
              className="btn-gradient btn-sm btn-round has-ripple ml-2 text-white"
              onClick={() => {
                funcion();
              }}
            >
              {" "}
              {`${nameButton} `}
              <i className="feather icon-plus" />
            </Button>
          </Col>
        ) : (
          ""
        )}
        <BTable
          className="modern-table"
          striped
          hover
          responsive
          {...getTableProps()}
        >
          <thead>
            {options ? (
              <tr key={`r${pageSize}`}>
                <th
                  colSpan={visibleColumns.length}
                  style={{
                    textAlign: "left",
                  }}
                >
                  <GlobalFilterGeneric
                    preGlobalFilteredRows={preGlobalFilteredRows}
                    globalFilter={state.globalFilter}
                    setGlobalFilter={setGlobalFilter}
                    filterBtn={filterBtn}
                    setfilterBtn={setfilterBtn}
                  />
                </th>
              </tr>
            ) : (
              ""
            )}
            {headerGroups.map((headerGroup) => {
              const { key, ...restProps } = headerGroup.getHeaderGroupProps();

              return (
                <tr key={key} {...restProps}>
                  {headerGroup.headers.map((column) => {
                    const { key: colKey, ...colRestProps } =
                      column.getHeaderProps(column.getSortByToggleProps());

                    return (
                      <th key={colKey} {...colRestProps} className="px-1">
                        {column.render("Header")}
                        <span>
                          {column.isSorted ? (
                            column.isSortedDesc ? (
                              <span className="feather icon-arrow-down text-muted float-right" />
                            ) : (
                              <span className="feather icon-arrow-up text-muted float-right" />
                            )
                          ) : (
                            ""
                          )}
                        </span>
                      </th>
                    );
                  })}
                </tr>
              );
            })}
          </thead>
          <tbody {...getTableBodyProps()}>
            {page.map((row, i) => {
              prepareRow(row);
              const { key: rowKey, ...rowRestProps } = row.getRowProps();

              return (
                <tr
                  key={rowKey}
                  onDoubleClick={doubleClic ? () => doubleClic(row) : undefined}
                  {...rowRestProps}
                >
                  {row.cells.map((cell) => {
                    const { key: cellKey, ...cellRestProps } =
                      cell.getCellProps();

                    return (
                      <td
                        style={{
                          background: "#ffffff",
                        }}
                        key={cellKey}
                        className={
                          cell.column.id === "action"
                            ? "action-cell-wrapper"
                            : cell.column.id === "imagen"
                              ? "cell-image"
                              : ""
                        }
                        {...cellRestProps}
                      >
                        <b>{cell.render("Cell")}</b>
                      </td>
                    );
                  })}
                </tr>
              );
            })}
          </tbody>
        </BTable>
        {pages ? (
          <div className="inv-table-footer">
            <div className="inv-footer-group">
              <span>
                Página{" "}
                <strong>
                  {" "}
                  {pageIndex + 1} of {pageOptions.length}{" "}
                </strong>{" "}
                | Ir a página:{" "}
                <input
                  type="number"
                  min="0"
                  className="inv-footer-input"
                  defaultValue={pageIndex + 1}
                  onChange={(e) => {
                    const page = e.target.value
                      ? Number(e.target.value) - 1
                      : 0;
                    gotoPage(page);
                  }}
                  style={{ width: "75px" }}
                />
              </span>
            </div>

            {options ? (
              <div className="inv-footer-group">
                <span className="d-flex align-items-center gap-2">
                  Mostrar
                  <select
                    className="form-control w-auto mx-2"
                    value={pageSize}
                    onChange={(e) => {
                      setPageSize(Number(e.target.value));
                    }}
                  >
                    {[5, 10, 20, 30, 40, 50].map((pageSize) => (
                      <option key={pageSize} value={pageSize}>
                        {pageSize}
                      </option>
                    ))}
                  </select>
                  registros
                </span>
              </div>
            ) : (
              ""
            )}

            <Pagination className="modern-pagination">
              <Pagination.First
                onClick={() => gotoPage(0)}
                disabled={!canPreviousPage}
              />
              <Pagination.Prev
                onClick={() => previousPage()}
                disabled={!canPreviousPage}
              />
              <Pagination.Next
                onClick={() => nextPage()}
                disabled={!canNextPage}
              />
              <Pagination.Last
                onClick={() => gotoPage(pageCount - 1)}
                disabled={!canNextPage}
              />
            </Pagination>
          </div>
        ) : (
          ""
        )}
      </div>
    </>
  );
}

export default GenericTable;
